import * as React from "react";
import * as moment from "moment";
import {Subscription} from "rxjs";
import {getAmountToDisplay} from "../../CommonFunctions";

interface IPaymentScheduleProps {
    isOpen: boolean;
    instalments: any[]; // instalments with possible gaps
}

interface IPaymentScheduleState {
    lastDoneInstalmentIndex: number;
}

export default class PaymentSchedule extends React.Component<IPaymentScheduleProps, IPaymentScheduleState> {

    private readonly progressContainerRef: React.RefObject<HTMLDivElement | null> = React.createRef();
    private readonly lastDoneInstalmentDotRef: React.RefObject<HTMLDivElement | null> = React.createRef();

    private windowResizeEventSubscription: Subscription;

    constructor(props: IPaymentScheduleProps) {
        super(props);

        this.state = {
            lastDoneInstalmentIndex: -1
        };
    }

    public componentWillUnmount() {
        if (this.windowResizeEventSubscription) {
            this.windowResizeEventSubscription.unsubscribe();
        }
    }

    public render() {
        return (
            <div className={`payment-schedule ${this.props.isOpen ? "payment-schedule--open" : ""}`}>
                <div
                    className="payment-schedule__progress-container"
                    ref={this.progressContainerRef}
                >
                    <div className="payment-schedule__progress">
                        <div className="payment-schedule__progress-bar"/>
                    </div>
                </div>
                <div className="payment-schedule__dot-container">
                    {this.props.isOpen ? this.renderVerticalDotsWithSchedule() : this.renderHorizontalDots()}
                </div>
            </div>
        );
    }

    private renderHorizontalDots = (): React.ReactNode => {
        return this.props.instalments.map((instalment, index) => {
            const isDone = index <= this.state.lastDoneInstalmentIndex;

            return (
                <div
                    key={instalment.month}
                    className={`progress-dot${isDone ? " progress-dot--paid" : ""}`}
                    ref={index === this.state.lastDoneInstalmentIndex ? this.lastDoneInstalmentDotRef : undefined}
                />
            );
        });
    }

    private renderVerticalDotsWithSchedule = (): React.ReactNode => {

        return this.props.instalments.map((instalment, index, instalments) => {

            const amount = instalment.principal + instalment.interest;

            return (
                <React.Fragment key={instalment.month}>
                    <div className="payment-schedule__grid-item instalment-text-color">
                        {moment(instalment.dueDate).format("DD MMM YYYY")}
                    </div>
                    <div className="payment-schedule__grid-item">
                        <div
                            className="progress-dot"
                            ref={index === this.state.lastDoneInstalmentIndex ? this.lastDoneInstalmentDotRef : undefined}
                        />
                    </div>
                    <div className="payment-schedule__grid-item payment-plan-item instalment-text-color">
                        {`${getAmountToDisplay(amount)}`} {index === 0 ? "(1st pay)" : ""}
                    </div>
                </React.Fragment>
            );
        });
    }
}
